import styled from 'styled-components';
import KebabSvg from 'images/svg/kebab.svg';

const Wrap = styled.div`
    position: absolute !important;
    top: 8px !important;
    right: 5px !important;
    z-index: 3 !important;

    width: 37px !important;
    height: 21px !important;

    .dropdown,
    .btn-group,
    #motili-text-button,
    [data-test-id='motili-text-button'],
    .MotiliTextButton_motili-text-button-group-container_8d1bb,
    .MotiliTextButton_motili-text-button-group-button-container_8404c,
    .MotiliTextButton_motiliTextButton_5dc44,
    .MotiliTextButton_motiliTextButton_0a49e {
        width: 37px !important;
        height: 21px !important;
        min-width: 37px !important;
        min-height: 21px !important;
        margin: 0 !important;
        padding: 0 !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        background: transparent !important;
        border: 0 !important;
        box-shadow: none !important;
    }
`;

const Icon = styled.img`
    width: 37px;
    height: 21px;
    display: block;
`;

export function KebabMenuButton({ children }: { children: React.ReactNode }) {
    return <Wrap>{children}</Wrap>;
}

export function KebabMenuIcon() {
    return <Icon src={KebabSvg} alt='More actions' />;
}
